import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 14 17",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M3.66668 7.81667C3.66668 7.35643 4.03977 6.98333 4.50001 6.98333H9.50001C9.96025 6.98333 10.3333 7.35643 10.3333 7.81667C10.3333 8.2769 9.96025 8.65 9.50001 8.65H4.50001C4.03977 8.65 3.66668 8.2769 3.66668 7.81667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M4.50001 10.3167C4.03977 10.3167 3.66668 10.6898 3.66668 11.15C3.66668 11.6102 4.03977 11.9833 4.50001 11.9833H7.83334C8.29358 11.9833 8.66668 11.6102 8.66668 11.15C8.66668 10.6898 8.29358 10.3167 7.83334 10.3167H4.50001Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.91683 1.15C9.53674 0.64398 8.9316 0.316666 8.25001 0.316666H5.75001C5.06842 0.316666 4.46328 0.64398 4.08319 1.15H2.83334C1.45263 1.15 0.333344 2.26929 0.333344 3.65V13.65C0.333344 15.0307 1.45263 16.15 2.83334 16.15H11.1667C12.5474 16.15 13.6667 15.0307 13.6667 13.65V3.65C13.6667 2.26929 12.5474 1.15 11.1667 1.15H9.91683ZM5.33334 2.4C5.33334 2.16988 5.51989 1.98333 5.75001 1.98333H8.25001C8.48013 1.98333 8.66668 2.16988 8.66668 2.4C8.66668 2.63012 8.48013 2.81667 8.25001 2.81667H5.75001C5.51989 2.81667 5.33334 2.63012 5.33334 2.4ZM3.70835 2.81667H2.83334C2.37311 2.81667 2.00001 3.18976 2.00001 3.65V13.65C2.00001 14.1102 2.37311 14.4833 2.83334 14.4833H11.1667C11.6269 14.4833 12 14.1102 12 13.65V3.65C12 3.18976 11.6269 2.81667 11.1667 2.81667H10.2917C10.0986 3.7676 9.25791 4.48333 8.25001 4.48333H5.75001C4.74211 4.48333 3.90138 3.7676 3.70835 2.81667Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}